import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import SizeChartReviewDataSheetCustomViewOptionsStore from "./SizeChartReviewDataSheetCustomViewOptionsStore";
import SizeChartReviewDataSheetOptions from "./SizeChartReviewDataSheetOptions";

const SizeChartReviewDataSheetViewOptions: FunctionComponent = observer(function SizeChartReviewDataSheetViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as SizeChartReviewDataSheetCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			dataCsiAutomation="CustomViewSizeChartOptions"
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewSizeChartOptions"
		>
			<SizeChartReviewDataSheetOptions />
		</CustomViewOptionCustomSection>
	);
});

export default SizeChartReviewDataSheetViewOptions;